<template>
  <div
    v-if="visible"
    class="br-sidebar-lock"
    :class="{ 'br-sidebar-lock--pending': pending }"
    role="dialog"
    aria-modal="true"
    aria-labelledby="br-sidebar-lock-title"
  >
    <div class="br-sidebar-lock__panel">
      <img
        class="br-sidebar-lock__icon"
        :src="lockIcon"
        alt=""
        aria-hidden="true"
      />
      <h2 id="br-sidebar-lock-title" class="br-sidebar-lock__title">{{ titleText }}</h2>
      <p class="br-sidebar-lock__body" v-html="bodyText"></p>
    </div>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrSidebarLockOverlay',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** AccessGate 拉取中：轻量文案，避免误读成已锁定 */
    pending: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    lockIcon() {
      return BR_LICENSE_ASSETS.lockIcon;
    },
    titleText() {
      return this.$t(
        this.pending
          ? 'lbl_EMPBE_BR_SidebarLock_PendingTitle'
          : 'lbl_EMPBE_BR_SidebarLock_Title',
      );
    },
    bodyText() {
      return this.$t(
        this.pending
          ? 'lbl_EMPBE_BR_SidebarLock_PendingBody'
          : 'lbl_EMPBE_BR_SidebarLock_Body',
      );
    },
  },
};
</script>
